module.exports = __webpack_public_path__ + "img/brandImg3.4bb850bb.jpg";